import { reactive } from "vue";
import toastService from "@/services/toastService";
import { API_BASE_URL, VERSIONE } from "@/config";

/**
 * Rilevamento di un nuovo rilascio del frontend.
 *
 * L'applicazione conosce la versione con cui e' stata distribuita; rilegge /version.json dal
 * server, che dopo un rilascio contiene quella nuova. Se differiscono, il browser sta
 * usando file vecchi: si accende il pulsante "Aggiorna" nel footer.
 *
 * Nessun sondaggio periodico: il controllo scatta al cambio pagina e quando si torna sulla
 * scheda, che sono i momenti in cui l'utente e' li' a guardare.
 */
// Dal config scritto all'avvio del container, non dal pacchetto: vedi VERSIONE in
// config.js. In sviluppo non c'e' nessun config e vale "sviluppo", che spegne il
// controllo qui sotto.
const CORRENTE = VERSIONE;
const state = reactive({ updateAvailable: false, serverVersion: null });
let avvisato = false;
// La versione del backend quando la pagina e' partita: un rilascio del solo backend non cambia /version.json, ma
// porta note, interruttori e pagine che questa scheda non conosce ancora.
let backendAllAvvio = null;

/** Se il backend e' cambiato da quando la pagina e' partita. Una rilettura leggera, e pubblica: niente token. */
async function backendCambiato() {
  try {
    const res = await fetch(`${API_BASE_URL}/public/diagnostic/version`, { cache: "no-store" });
    if (!res.ok) return false;
    const versione = (await res.json())?.data?.version;
    if (!versione) return false;
    if (backendAllAvvio === null) backendAllAvvio = versione;
    return versione !== backendAllAvvio;
  } catch (e) {
    return false;
  }
}

async function check() {
  // In sviluppo non ha senso, e una volta rilevato non serve ricontrollare.
  //
  // Nell'app nemmeno: le pagine stanno dentro l'APK, e l'aggiornamento arriva installando un
  // APK nuovo, non ricaricando. /version.json li' non esiste (il server locale di Capacitor
  // risponde 404), quindi oggi il controllo uscirebbe comunque: lo si spegne esplicitamente
  // invece di affidarsi a un 404.
  if (process.env.VUE_APP_PIATTAFORMA === "mobile" || CORRENTE === "sviluppo" || state.updateAvailable) return;
  try {
    const res = await fetch("/version.json?_=" + Date.now(), { cache: "no-store" });
    if (!res.ok) return;
    const servita = (await res.json()).version;
    const frontendCambiato = servita && servita !== CORRENTE;
    if (frontendCambiato || await backendCambiato()) {
      state.serverVersion = servita;
      state.updateAvailable = true;
      // Una volta sola: ripeterlo a ogni cambio pagina diventerebbe rumore, e il
      // pulsante nel footer resta li' a ricordarlo.
      //
      // Il testo dice di ricaricare, che e' quello che fa il pulsante (reload qui sotto),
      // e non rimanda al pulsante: sotto i 576 pixel il footer non lo mostra, e nei
      // messaggi sul telefono il footer non c'e' proprio (views/messages/index.vue).
      if (!avvisato) {
        avvisato = true;
        toastService.info(
          "È disponibile una versione aggiornata: ricarica la pagina per caricarla.",
          "Nuova versione"
        );
      }
    }
  } catch (e) {
    // offline, oppure version.json assente in una build locale: si ignora.
  }
}

function reload() {
  window.location.reload();
}

export const appUpdate = { state, check, reload, versione: CORRENTE };
export default appUpdate;
